<template>
  <div>
    <header-mx :seccion="seccion"></header-mx>
    <section class="main">
      <div class="figuras interior">
        <div class="container video">
          <div
            class="row"
            data-aos="fade-up"
            data-aos-delay="200"
            data-aos-duration="500"
          >
            <div class="col-12">
              <div class="row pt-2 pb-4 pt-lg-0">
                <div class="col-12 pb-4 text-center" v-if="cursos != null">
                  <span class="rojo fXG2 pb-4 d-block">
                    {{ cursos[index].clase }}
                  </span>

                  <p class="fG pb-4">
                    <strong
                      >Bienvenido a la sección de
                      {{ cursos[index].nombre_amigable }}</strong
                    >
                  </p>
                  <div class="fG" v-html="cursos[index].descripcion"></div>

                  <div class="py-4" v-if="cursos[index].video != ''">
                    <img
                      class="img-fluid"
                      :src="
                        require('../../assets/imgs/coca/' + cursos[index].video)
                      "
                      alt="Video"
                    />
                  </div>

                  <div class="py-4 fG row text-left">
                    <div
                      class="col-12"
                      v-html="cursos[index].instrucciones"
                    ></div>
                  </div>

                  <div class="row pt-5">
                    <div
                      class="col-12 col-lg-6 pb-5"
                      v-for="curso in cursos[index].subcursos"
                      :key="curso.id"
                    >
                      <div class="row">
                        <div class="col-10 offset-1 col-lg-10 offset-lg-0">
                          <router-link
                            :to="'/curso/' + cursos[index].id + '/' + curso.id"
                            class="tarjetamodelo d-block row"
                          >
                            <div class="imagen">
                              <img
                                :src="
                                  require('../../assets/imgs/coca/' +
                                    curso.imagen)
                                "
                                :alt="curso.nombre"
                                class="img-fluid"
                              />
                            </div>
                            <div
                              class="
                                texto
                                pt-5
                                pb-4
                                pl-5
                                fG
                                col-9
                                offset-2
                                text-left
                              "
                            >
                              <p v-html="curso.nombre"></p>
                              <p v-html="curso.ubicacion"></p>
                            </div>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="col-12 pb-3">
                <div class="row">
                  <div class="col-12 text-center">
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-none d-lg-block"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_desk.jpg"
                        alt="recetario"
                      />
                    </a>
                    <a
                      href="https://www.superama.com.mx/micrositio/recetas-maestros-de-la-parrilla/"
                      class="d-block d-lg-none"
                      target="_blank"
                      @click="clickComprar()"
                    >
                      <img
                        class="img-fluid"
                        src="../../assets/imgs/banner_mdlp_mobile.jpg"
                        alt="recetario"
                      />
                    </a>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <footer-mx></footer-mx>
    </section>
  </div>
</template>

<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/HeaderInterior.vue";
import Footer from "../../Components/Footer.vue";
import Vue from "vue";
// import Vue2TouchEvents from "vue2-touch-events";
// Vue.use(Vue2TouchEvents);
import { Carousel3d, Slide } from "vue-carousel-3d";

//Vue.use(Carousel3d);

export default {
  name: "AcademiaDigital",
  props: {
    msg: String,
  },
  data() {
    return {
      email: "",
      password: "",
      info: false,
      cursos: null,
      index: -1,
      seccion: "",
      subseccion: "",
    };
  },
  mounted: function () {
    //this.$store.state.user = JSON.parse(this.$cookie.get("useracademiadigital"));

    this.initAll();
  },
  components: {
    "header-mx": Header,
    "footer-mx": Footer,
  },
  methods: {
    initAll() {

      
      this.$store.state.user = localStorage.getItem("useracademiadigital");

      console.log({uservideo: this.$store.state.user});

      AOS.init();
      this.cursos = this.$store.state.cursos;
      this.index = this.$route.params.id;

      console.log({ cursos: this.cursos });

      this.seccion = this.cursos[this.index].clase;
    },
    clickComprar() {
      this.$gtag.event("Click comprar", {
        event_category: "MDLP",
      });
    },
    clickRecetario() {
      this.$gtag.event("Descarga recetario", {
        event_category: "MDLP",
      });
    },
    toggleInfo() {
      this.info = !this.info;
    },
    onAfterSlideChange(index) {
      console.log(
        "@onAfterSlideChange Callback Triggered",
        "Slide Index " + index
      );
      this.index = index;
    },
    swipeHandler(direction) {
      console.log(direction); // May be left / right / top / bottom
    },
  },
  watch: {
    $route(to, from) {
      // react to route changes...

      this.initAll();
    },
  },
};
</script>

